import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { MarketingOptInTypes, Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import Switch from '@ui/switch/switch';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';

export default function MarketingOptInToggle() {
  const dispatch = useAppDispatch();
  const { registrationSettings, singleSignOnEnabled } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);

  const marketingEmailOptions = registrationSettings?.marketing_email_options;
  const isSingleOptIn = marketingEmailOptions === MarketingOptInTypes.singleOptIn;
  const isDoubleOptIn = marketingEmailOptions === MarketingOptInTypes.doubleOptIn;
  const isNoOptIn = !isSingleOptIn && !isDoubleOptIn;

  const toggleSingleOptIn = (value: boolean, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      marketing_email_options: on ? MarketingOptInTypes.singleOptIn : MarketingOptInTypes.noOptIn,
    };

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  const toggleDoubleOptIn = (value: boolean, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      marketing_email_options: on ? MarketingOptInTypes.doubleOptIn : MarketingOptInTypes.singleOptIn,
    };

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <Container design="GlobalCont1" borderRadius="12px" padding="16px" className="flex fd-column gap-12">
      <div className="flex ai-center jc-space-between">
        <Text tag="h6" className="H6">
          Opt into marketing emails
        </Text>
        <Switch
          disabled={savingWorkingProject || singleSignOnEnabled}
          value={!isNoOptIn}
          on={!isNoOptIn}
          onClick={toggleSingleOptIn}
        />
      </div>
      <div className="flex ai-center jc-flex-end">
        <Container design="GlobalCont2" borderRadius="12px" padding="6px 6px 6px 10px" className="flex gap-8 ai-center">
          <Text className="S3" color="var(--global-ico-text-3)">
            Double opt-in
          </Text>
          <Switch
            value={isDoubleOptIn}
            disabled={isNoOptIn || singleSignOnEnabled || savingWorkingProject}
            on={isDoubleOptIn}
            onClick={toggleDoubleOptIn}
          />
        </Container>
      </div>
    </Container>
  );
}
